export default __webpack_public_path__ + "static/media/bg.36bdab6d.png";